import axios from "../Axios/Default";
// axios.defaults.baseURL = process.env.REACT_APP_URL_HUAWEI;
// const access_token = localStorage.getItem("access_token");
// axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const GetElecticPrice = (stasion_id) => {
  const promise = axios.get("/electric-price/get/" + stasion_id, config);
  return promise;
};

export const doUpdateElectricPrice = (payload, id) => {
  const promise = axios.put("/electric-price/update/" + id , payload, config);
  return promise;
};

export const GetDataStatisticMonth = (stasion_id, payload) => {
  const promise = axios.post("/scheduler-data/get-monthly/" + stasion_id, payload, config);
  return promise;
};

export const GetDataStatisticMonthByDay = (stasion_id, payload) => {
  const promise = axios.post("/scheduler-data/get-monthly-day/" + stasion_id, payload, config);
  return promise;
};

export const GetDataStatisticYear = (stasion_id, payload) => {
  const promise = axios.post("/scheduler-data/get-yearly/" + stasion_id, payload, config);
  return promise;
};

export const GetDataStatisticLifeTime = (stasion_id, payload) => {
  const promise = axios.post("/scheduler-data/get-lifetime/" + stasion_id, payload, config);
  return promise;
};


export const GetDataStatisticHourly = (stasion_id, payload) => {
  // alert('here')
  const promise = axios.post("/scheduler-data/get-daily/" + stasion_id, payload, config);
  return promise;
};
